import { render, staticRenderFns } from "./AdminNonGYServiceLogList.vue?vue&type=template&id=9dca6fd2&scoped=true"
import script from "./AdminNonGYServiceLogList.vue?vue&type=script&lang=js"
export * from "./AdminNonGYServiceLogList.vue?vue&type=script&lang=js"
import style0 from "./AdminNonGYServiceLogList.vue?vue&type=style&index=0&id=9dca6fd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dca6fd2",
  null
  
)

export default component.exports